import './styles.scss'
import PriceFileContent from './PriceFileContent/PriceFileContent'
import { CreateSurvey } from '../RFPSurvey/CreateSurvey'

export const RFPVoting = () => {
  return (
    <div className="rfp-voting-container">
      <div className="rfp-voting-content">
        <PriceFileContent />
        <CreateSurvey />
      </div>
    </div>
  )
}
